import TeamBlock from "./TeamBlock";

export default TeamBlock;
